/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useEffect, useContext, useRef } from "react";
import BasemapGallary from "@arcgis/core/widgets/BasemapGallery";
import Button from "calcite-react/Button";
import Basemap from "@arcgis/core/Basemap";
import BasemapIcon from "calcite-ui-icons-react/BasemapIcon";

import "./BasemapSelector.scss";
import { MapContext } from "../../context/MapContext";
import { IconButton } from "@material-ui/core";
import XIcon from "calcite-ui-icons-react/XIcon";
import { LayoutContext } from "../../context/LayoutContext";

function BasemapSelector(props) {
  const {
    basemapOpen,
    setBasemapOpen,
    setBasemap,
    measureToolOpen,
    setMeasureToolOpen,
    areaToolOpen,
    setAreaToolOpen,
    viewLegendOpen,
    setViewLegendOpen,
    closeAppDrawer,
  } = props;
  const basemapDiv = useRef(null);
  const [mapObject] = useContext(MapContext);
  const { mobileActive } = useContext(LayoutContext);

  useEffect(() => {
    if (basemapDiv.current && mapObject?.view) {
      const gallery = new BasemapGallary({
        container: basemapDiv.current,
        view: mapObject.view,
        source: [
          Basemap.fromId("oceans"),
          Basemap.fromId("hybrid"),
          Basemap.fromId("gray-vector"),
          Basemap.fromId("dark-gray-vector"),
          Basemap.fromId("national-geographic"),
          Basemap.fromId("satellite"),
          Basemap.fromId("streets-vector"),
          Basemap.fromId("terrain"),
          Basemap.fromId("topo-vector"),
        ],
      });

      gallery.watch("activeBasemap", (newValue) => setBasemap(newValue.id));
    }
  }, [basemapDiv, mapObject?.view, setBasemap]);

  const toggleBasemapGallery = (b) => {
    if (b) {
      measureToolOpen && setMeasureToolOpen(false);
      areaToolOpen && setAreaToolOpen(false);
      viewLegendOpen && setViewLegendOpen(false);
      closeAppDrawer && closeAppDrawer();
    }
    setBasemapOpen(b);
  };

  return (
    <div className="basemapSelector">
      <Button
        className={`basemapToggle ${basemapOpen ? " active" : ""}`}
        title="Basemap Selector"
        onClick={() => toggleBasemapGallery(!basemapOpen)}
        icon={<BasemapIcon size={16} />}
      ></Button>
      <div
        className={basemapOpen ? "basemapContainer" : "basemapContainer hidden"}
        ref={basemapDiv}
        onClick={() => setBasemapOpen(false)}
      >
        {mobileActive && (<div>
          <IconButton
            aria-label="Select base map"
            className="closeButton"
            onClick={() => {
              setBasemapOpen(false)
            }}
          >
            <XIcon />
          </IconButton>
        </div>)}
      </div>
    </div>
  );
}

export default BasemapSelector;
